export default __webpack_public_path__ + "static/media/HondaCAFavicon.4638b270.svg";